<template>
    <div>
        <Desktop
            @change-profile="$emit('change-profile')"
            @push-route="pushRoute"
            @logout="logoutWithRedirect"
            v-if="!isMobile"
            :logo="logo"
            :showPartnerLogo="showPartnerLogo"
        />
        <Mobile
            :logo="logo"
            :showPartnerLogo="showPartnerLogo"
            @change-profile="$emit('change-profile')"
            @push-route="pushRoute"
            :show="show"
            @show="showAction()"
            @logout="logoutWithRedirect"
            v-else
        />
    </div>
</template>

<script>
import Mobile from '@/layouts/header/contractor/mobile.vue';
import Desktop from '@/layouts/header/contractor/desktop.vue';
import { mapActions, mapState } from 'vuex';
export default {
    components: { Mobile, Desktop },
    name: 'HeaderContractor',
    data () {
        return {
            isMobile: '',
            show: false
        };
    },
    created () {
        if (this.user.partner) {
            if (this.user.partner.name.toLowerCase() == 'cipa') {
                document.body.classList.add('cipa');
            }
        } else {
            document.body.classList.remove('cipa');
        }
    },
    methods: {
        ...mapActions('user', ['logout']),
        showAction () {
            this.show = !this.show;
            this.$emit('show', this.show);
        },
        logoutWithRedirect () {
            this.logout();
            this.$router.push({ name: 'LandingPage' });
        },
        pushRoute (objectUrl) {
            if (objectUrl.solo) {
                window.open(objectUrl.url, '_blank');
            } else if (objectUrl.url && this.$route.name != objectUrl.url) {
                this.$router.push({ name: objectUrl.url, query: objectUrl.queryString });
            }
            this.show = false;
            this.$emit('show', this.show);
        }
    },
    computed: {
        ...mapState('user', ['user']),
        logo () {
            // if (this.user.partner) {
            //     return this.user.partner.name.toLowerCase() == 'cipa'
            //         ? `${process.env.VUE_APP_STATIC_BASE_URL}/logos/Engelink CIPA.svg`
            //         : require('@/assets/images/engelink_logo.svg');
            // }require('@/assets/images/cipa-logo.svg');
            return require('@/assets/images/engelink_logo.svg');
        },
        showPartnerLogo () {
            if (this.user.partner) return this.user.partner.name.toLowerCase() == 'cipa';
            else return false;
        }
    },
    mounted () {
        const vue = this;
        window.addEventListener('resize', () => {
            vue.isMobile = window.innerWidth <= 1280;
        });
        vue.isMobile = window.innerWidth <= 1280;
    },
    destroyed( ) {
        document.body.classList.remove('cipa');
    }
};
</script>
